import { configureStore } from '@reduxjs/toolkit';
import templateReducer from '../features/templates/TemplatesSlice';
import productsReducer from '../features/products/ProductsSlice';
import { useDispatch } from 'react-redux';

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types

export const store = configureStore({
	reducer: {
		templates: templateReducer,
		products: productsReducer,
	},
});
